/* eslint-disable import/order */
import React from 'react'
import Icon from '@mdi/react'
import { mdiChevronLeft, mdiChevronRight, mdiMessageQuestion } from '@mdi/js'
import colors from '../../../assets/colors'
import { Grid, IconButton, Typography, makeStyles } from '@material-ui/core'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { useHistory } from 'react-router-dom'
import { useNavigator } from '../../../hooks/useNavigator'

const useStyles = makeStyles({
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
  root: {
    animation: '$fadeIn 1s ease-in-out',
  },
  pageLink: {
    width: 'auto',
    '&:hover': {
      backgroundColor: 'inherit',
    },
  },
  page: {
    fontSize: '14px',
    color: colors.textGray,
    fontWeight: 'normal',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: 'inherit',
      color: colors.primary,
    },
  },
  path: {
    fontSize: '20px',
    color: colors.primary,
    fontWeight: '700',
    position: 'relative',
  },
  questionBox: {
    padding: 0,
    position: 'absolute',
    top: '-15px',
    right: '-25px',
  },
})

const BaseCreatePage = ({
  page,
  pageLink,
  path,
  helperLink,
  helperLinkBtn = false,
  handleClickHelperLink = () => {},
  hiddenReturn = false,
  goBack = false,
  children,
  xs = false,
  titleSize = 6,
}) => {
  const classes = useStyles()
  const history = useHistory()

  const navigator = useNavigator()

  return (
    <Grid className={classes.root} spacing={4} direction="column">
      <Grid item container xs={12}>
        <Grid item xs={titleSize}>
          <Grid container alignItems="center">
            {page && (
              <>
                <IconButton
                  component={Link}
                  to={pageLink}
                  className={classes.pageLink}
                  style={{ padding: 0 }}
                >
                  <Typography
                    variant="h6"
                    color="inherit"
                    className={classes.page}
                    style={{ fontSize: xs ? '12px' : '' }}
                  >
                    {page}
                  </Typography>
                </IconButton>

                <Icon
                  path={mdiChevronRight}
                  size={xs ? 0.8 : 1}
                  color={colors.textPrimary}
                />
              </>
            )}

            <Typography
              variant="h6"
              color="inherit"
              className={classes.path}
              style={{ fontSize: xs ? '12px' : '' }}
            >
              {path}

              {helperLink && (
                <IconButton className={classes.questionBox}>
                  {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}

                  <a href={helperLink} target="_blank" rel="noreferrer">
                    <Icon
                      path={mdiMessageQuestion}
                      size={1}
                      color={colors.secondary}
                    />
                  </a>
                </IconButton>
              )}

              {helperLinkBtn && (
                <IconButton
                  className={classes.questionBox}
                  onClick={handleClickHelperLink}
                >
                  <Icon
                    path={mdiMessageQuestion}
                    size={1}
                    color={colors.secondary}
                  />
                </IconButton>
              )}
            </Typography>
          </Grid>
        </Grid>

        {!hiddenReturn && (
          <Grid item xs={6} container display="flex" justifyContent="flex-end">
            <IconButton
              component={Link}
              to={pageLink}
              className={classes.pageLink}
            >
              <Icon path={mdiChevronLeft} size={1} color={colors.textPrimary} />

              <Typography variant="h6" color="inherit" className={classes.page}>
                Voltar
              </Typography>
            </IconButton>
          </Grid>
        )}

        {goBack && (
          <Grid item xs={6} container display="flex" justifyContent="flex-end">
            <IconButton
              onClick={() => {
                navigator.goBack()
              }}
              className={classes.pageLink}
            >
              <Icon path={mdiChevronLeft} size={1} color={colors.textPrimary} />

              <Typography variant="h6" color="inherit" className={classes.page}>
                Voltar
              </Typography>
            </IconButton>
          </Grid>
        )}

        {children}
      </Grid>
    </Grid>
  )
}

export default BaseCreatePage
